export interface EmailLinkProps {
    emailAddress: string | undefined;
}

export const EmailLink: React.FC<EmailLinkProps> = ({ emailAddress }) => {
    const handleClick = () => {
        location.href = `mailto:${emailAddress}`;
    };

    return (
        <>
            <div>
                {emailAddress && <a onClick={handleClick}>{emailAddress}</a>}
                {!emailAddress && <div>No Email Assigned</div>}
            </div>
        </>
    );
};
